import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
const TOTAL = 100;
export function ScarcityBar() {
  const [left, setLeft] = useState(7);
  useEffect(() => {
    const id = window.setInterval(() => {
      setLeft(v => v > 3 ? v - 1 : v);
    }, 45000);
    return () => window.clearInterval(id);
  }, []);
  const pct = (TOTAL - left) / TOTAL * 100;
  return <div className="w-full max-w-xl" data-id="element-410" data-mp="37v9pc52jjyns">
      <div className="flex items-center justify-between gap-3 text-sm font-bold" data-id="element-411" data-mp="32xrg0dkm3hf9">
        <span className="flex items-center gap-1.5 text-gold" data-id="element-412" data-mp="32vncvxujemg1">
          <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-413" data-mp="3gnuvmlozkcvq" />
          High demand
        </span>
        <span className="text-white" data-id="element-414" data-mp="3couf59tzdmbw">
          Only <span className="text-gold" data-id="element-415" data-mp="3cpx7lm6ybwtx">{left} spots</span> left at $27
        </span>
      </div>
      <div className="mt-2 h-5 w-full overflow-hidden rounded-full bg-white/10 ring-1 ring-white/15" role="progressbar" aria-valuenow={Math.round(pct)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-416" data-mp="3qkzk4s6b0kfp">
        <motion.div className="flex h-full items-center justify-end rounded-full bg-gold pr-2" initial={{
        width: '60%'
      }} whileInView={{
        width: `${pct}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-417" data-mp="13gzm1tnrbrss">
          <span className="text-[11px] font-black text-ink" data-id="element-418" data-mp="1heeivjgcb1us">{Math.round(pct)}% claimed</span>
        </motion.div>
      </div>
      <p className="mt-2 text-center text-xs text-white/70" data-id="element-419" data-mp="1r6bugrb9fvu1">
        When the remaining spots are gone, the price returns to $97 USD.
      </p>
    </div>;
}